import { jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from 'react';
/**
 * Per-element error boundary. Wraps each rendered primitive so a single
 * malformed or unexpected widget — bad agent-authored props, an unknown
 * block shape slipping past validation, etc. — can't take down the rest of
 * the tree. Logs and renders a small fallback card instead of crashing.
 *
 * Used both by `DigestView`/`renderBlock` (M1) and by the json-render
 * registry built in `catalog.ts` (M2) so both render paths degrade the
 * same way.
 */
export class PrimitiveErrorBoundary extends Component {
    state = { hasError: false };
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    componentDidCatch(error, info) {
        // eslint-disable-next-line no-console
        console.error(`[@almanac/catalog] failed to render "${this.props.label}"`, error, info.componentStack);
    }
    render() {
        if (this.state.hasError) {
            return (_jsxs("div", { className: "rounded-lg border border-dashed border-danger/30 bg-danger/10 p-3 text-xs text-danger", children: ["Couldn't render \u201C", this.props.label, "\u201D."] }));
        }
        return this.props.children;
    }
}
